import React, { useEffect, useState } from 'react';
import Combobox, { IComboBoxItem } from '../../../../../../components/Common/UI/Combobox';
import { StatusBadge } from '../../../../../../components/Common/StatusBadge';
import { AccountManagementRes } from '../../columns';

interface IAccountInfo {
  account: AccountManagementRes;
  allAccounts: AccountManagementRes[];
  handleSelect: (payload?: IComboBoxItem) => void;
}

function AccountInfo({ account, handleSelect, allAccounts }: IAccountInfo) {
  const [options, setOptions] = useState<IComboBoxItem[]>([]);

  useEffect(() => {
    setOptions(
      allAccounts.map(el => ({
        label: `${el.accountType} ${el.accountNumber}`,
        value: el.id,
      })),
    );
  }, []);

  return (
    <div className="rounded-lg border overflow-hidden">
      <div className="flex items-center gap-[20px] bg-[#5582B42E] p-[10px] min-h-[64px] justify-between">
        <div className="pl-[10px] font-bold text-primary text-[20px]">Account Information</div>
        {options.length ? <Combobox items={options} selected={account} handleSelect={handleSelect} isTrim /> : null}
      </div>
      <div className="p-[20px] grid gap-[10px]">
        <div className="flex gap-[20px] justify-between items-center">
          <div className="grid grid-cols-[200px,auto] gap-[10px]">
            <div className="opacity-80 text-primary">Account Status:</div>
            <StatusBadge status={account.status} />
          </div>
        </div>
        <div className="grid gap-[10px]">
          <div className="grid grid-cols-[200px,auto] gap-[10px]">
            <div className="opacity-80 text-primary">Account Number:</div>
            <div className="font-medium">{account.accountNumber}</div>
          </div>
          <div className="grid grid-cols-[200px,auto] gap-[10px]">
            <div className="opacity-80 text-primary">Account Type:</div>
            <div className="font-medium">{account.accountType}</div>
          </div>
          <div className="grid grid-cols-[200px,auto] gap-[10px]">
            <div className="opacity-80 text-primary">Account Description:</div>
            <div className="font-medium" />
          </div>
          <div className="grid grid-cols-[200px,auto] gap-[10px]">
            <div className="opacity-80 text-primary">Account Owner:</div>
            <div className="font-medium">{account.accountName}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountInfo;
